import Constants from '../../constants/column-name/column-name.constants';

export default {
  Customer: {
    store: 'Customer',
    lookups: {
      idField: Constants.Customer.customerId.field,
      codeField: Constants.Customer.customerCode.field,
      nameField: Constants.Customer.customerName.field,
      searchField: Constants.Customer.customerSearchField.field
    },
    formProps: {
      idField: Constants.Unit.customerId.field,
      codeField: Constants.Unit.customerCode.field,
      nameField: Constants.Unit.customerName.field
    },
    otherMappedProps: {
      [Constants.Unit.customerComment.field]: Constants.Customer.comments.field
    },
    optionLabelProp: Constants.Unit.customerCode.field,
    infoField: Constants.Unit.customerComment.field,
    isServerSide: true,
    serverSearchKey: 'CustomerSearchFieldQuery',
    serverIdKey: 'CustomerIdQuery'
  },
  Fluid: {
    store: 'Fluid',
    lookups: {
      idField: Constants.Fluid.fluidId.field,
      codeField: Constants.Fluid.fluidKeywords.field,
      nameField: Constants.Fluid.fluidSearchField.field,
      searchField: Constants.Fluid.fluidSearchField.field
    },
    formProps: {
      idField: Constants.Unit.defaultFluidId.field,
      codeField: Constants.Unit.defaultFluidKeywords.field,
      nameField: Constants.Unit.defaultFluidSearchField.field
    },
    isServerSide: true,
    serverSearchKey: 'FluidSearchFieldQuery',
    searchOnOpen: true
  },
  ManufacturerModel: {
    store: 'ManufacturerModel',
    lookups: {
      idField: Constants.ManufacturerModel.manufacturerModelId.field,
      codeField: Constants.ManufacturerModel.manufacturerModelCode.field,
      nameField: Constants.ManufacturerModel.manufacturerModelSearchField.field,
      searchField: Constants.ManufacturerModel.manufacturerModelSearchField.field
    },
    formProps: {
      idField: Constants.Unit.manufacturerModelId.field,
      codeField: Constants.Unit.manufacturerModelCode.field,
      nameField: Constants.Unit.manufacturerModelName.field
    },
    isServerSide: true,
    serverSearchKey: 'ManufacturerModelSearchFieldQuery',
    searchOnOpen: true
  },
  UnitType: {
    store: 'UnitType',
    lookups: {
      idField: Constants.UnitType.unitTypeId.field,
      codeField: Constants.UnitType.unitTypeName.field,
      nameField: Constants.UnitType.unitTypeName.field
    },
    formProps: {
      idField: Constants.Unit.unitTypeId.field,
      codeField: Constants.Unit.unitTypeName.field,
      nameField: Constants.Unit.unitTypeName.field
    },
    isServerSide: true,
    serverSearchKey: 'UnitTypeSearchFieldQuery',
    searchOnOpen: true
  },
  FluidUnitOfMeasure: {
    store: 'UnitOfMeasure',
    lookups: {
      idField: Constants.UnitOfMeasure.unitOfMeasureID.field,
      codeField: Constants.UnitOfMeasure.unitOfMeasureName.field,
      nameField: Constants.UnitOfMeasure.unitOfMeasureName.field
    },
    formProps: {
      idField: Constants.Unit.defaultFluidUnitOfMeasureId.field,
      codeField: Constants.Unit.defaultFluidUnitOfMeasureName.field,
      nameField: Constants.Unit.defaultFluidUnitOfMeasureName.field
    },
    typeCode: 'fluid'
  },
  MeterReadingUnitOfMeasure: {
    store: 'UnitOfMeasure',
    lookups: {
      idField: Constants.UnitOfMeasure.unitOfMeasureID.field,
      codeField: Constants.UnitOfMeasure.unitOfMeasureName.field,
      nameField: Constants.UnitOfMeasure.unitOfMeasureName.field
    },
    formProps: {
      idField: Constants.Unit.defaultReadingUnitOfMeasureId.field,
      codeField: Constants.Unit.defaultReadingUnitOfMeasureName.field,
      nameField: Constants.Unit.defaultReadingUnitOfMeasureName.field
    },
    typeCode: 'reading'
  }
};
